import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { Header, Button } from '../../../styles/common/Dialog';

export const DialogButton = styled(Button)`
  margin: 10px;
  background-color: ${ColorSF2.white};
  border: 1px solid ${ColorSF2.mediumGray};
`;

export const DialogHeader = styled(Header)`
  height: 40px;
`;

export const DeleteButton = styled(Button)`
  margin: 10px;
  background-color: ${ColorSF2.red};
  color: ${ColorSF2.white};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const MessageContainer = styled.div`
  text-align: start;
  height: 80px;
  margin: 20px;
`;
